/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ProgramStudent from './ProgramStudent'


interface IProps {
  student: any
  tabText?: string
  tabKey?: string
}

const StudentProgram: FC<IProps> = ({student}) => {

  const { t } = useTranslation()

  return (
    <>
        <ProgramStudent student={student.student_profile_id} />
    </>
  )
}

export default StudentProgram
